module.exports = __webpack_public_path__ + "static/media/assorted-ice-cream-scoops.55ad914c.jpeg";